<script setup lang="ts">
import { useGlobals } from '@/helpers/globals';

const globals = useGlobals();
</script>


<template>
    <div v-if="globals.environment !== 'prod'" class="ktg-main-container">
        <h1 class="ktg-title-01">Impressum</h1>
        <p class="ktg-body-small">
            Als erste Ansprechperson bei Fragen, Problemen oder Anregungen zum Baugesuchsprozess oder zu
            Planungsgeschäften wenden Sie sich bitte zuerst an die Bauverwaltung Ihrer Gemeinde.
        </p>

        <h2 class="ktg-title-02 mt-3rem">Kontakt</h2>

        <h3 class="ktg-title-03 mt-1_5rem">Kanton Thurgau</h3>
        <p class="ktg-body-small">
            Departement für Bau und Umwelt<br />
            Baugesuchszentrale<br />
            Verwaltungsgebäude<br />
            8510 Frauenfeld<br />
            <a href="https://dbu.tg.ch/baugesuchszentrale.html/15214">https://dbu.tg.ch/baugesuchszentrale.html/15214</a
            ><br />
            Tel. <a href="tel:+41583453280">+41 58 345 32 80</a><br />
            E-Mail: <a href="mailto:baugesuchszentrale.dbu@tg.ch">baugesuchszentrale.dbu@tg.ch</a>
        </p>

        <h3 class="ktg-title-03 mt-1_5rem">Verband Thurgauer Gemeinden</h3>
        <p class="ktg-body-small">
            Ressort Bau, Werke, Umwelt<br />
            Thomas-Bornhauser-Strasse 23a<br />
            8570 Weinfelden<br />
            <a href="https://www.vtg.ch/">https://www.vtg.ch/</a>
        </p>

        <ktg-line class="mt-1_5rem"></ktg-line>

        <h3 class="ktg-title-03 mt-3rem">Entwicklung und Umsetzung</h3>

        <h4 class="ktg-title-04 mt-1_5rem">Kaden & Partner AG</h4>
        <p class="ktg-body-small">
            Bahnhofstrasse 43<br />
            8500 Frauenfeld<br />
            <a href="https://www.kadenpartner.ch">https://www.kadenpartner.ch</a>
        </p>

        <h4 class="ktg-title-04 mt-1_5rem">GBL Gubler AG</h4>
        <p class="ktg-body-small">
            Breitenstrasse 16b<br />
            8500 Frauenfeld<br />
            <a href="https://gbl-gubler.ch">https://gbl-gubler.ch</a>
        </p>

        <h4 class="ktg-title-04 mt-1_5rem">Kanton Thurgau</h4>
        <p class="ktg-body-small">
            Amt für Geoinformation<br />
            Promenadenstrasse 8<br />
            8510 Frauenfeld<br />
            <a href="https://geoinformation.tg.ch/">https://geoinformation.tg.ch/</a>
        </p>

        <ktg-line class="mt-1_5rem"></ktg-line>

        <h3 class="ktg-title-03 mt-3rem">Betrieb</h3>

        <h4 class="ktg-title-04 mt-1_5rem">Kanton Thurgau</h4>
        <p class="ktg-body-small">
            Amt für Informatik<br />
            Im Roos 6<br />
            8570 Weinfelden<br />
            <a href="http://www.informatik.tg.ch">www.informatik.tg.ch</a>
        </p>

        <ktg-line class="mt-1_5rem"></ktg-line>

        <h3 class="ktg-title-03 mt-1_5rem">Copyright</h3>
        <p class="ktg-body-small mt-1_5rem mb-1_5rem">
            Die auf dieser Site angebotenen Inhalte können für private Zwecke ohne Einschränkungen verwendet werden. Für
            professionellen/gewerblichen Gebrauch muss die Einwilligung des Herausgebers eingeholt werden.
        </p>
    </div>
    <div v-else class="ktg-main-container mb-3rem">Die Seite befindet sich erst im Aufbau</div>
</template>
